import { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { ReportFooter } from "@/components/ReportFooter";
import { useLanguageWithOverride, Language } from "@/hooks/use-browser-language";
import { getCookieTranslation } from "@/i18n/cookie-policy";

const CookiePolicy = () => {
  const { language, setLanguage } = useLanguageWithOverride();
  
  const t = (key: Parameters<typeof getCookieTranslation>[1]) => 
    getCookieTranslation(language, key);

  const toggleLanguage = () => {
    const newLang: Language = language === "pl" ? "en" : "pl";
    setLanguage(newLang);
    const url = new URL(window.location.href);
    url.searchParams.set("lang", newLang);
    window.history.replaceState({}, "", url.toString());
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'cky-cookie-policy';
    script.type = 'text/javascript';
    script.src = 'https://cdn-cookieyes.com/client_data/9641d01acff50ccbbd48749ac08d5204/cookie-policy/script.js';
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('cky-cookie-policy');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <ScrollArea className="h-screen w-full">
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 py-12">
        <div className="container max-w-4xl mx-auto px-4">
          <Card className="shadow-xl border-primary/20">
            <CardHeader className="text-center pb-6 border-b border-border/40">
              <CardTitle className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
                {t("title")}
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-8">
              <div id="cky-cookie-policy" className="prose prose-slate max-w-none">
                {/* CookieYes script will inject content here */}
              </div>

              {/* Language Switcher */}
              <div className="flex justify-center pt-8 border-t border-border/40 mt-8">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={toggleLanguage}
                  className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
                >
                  <Globe className="h-4 w-4" />
                  <span className="font-medium">{language === "pl" ? "English" : "Polski"}</span>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <ReportFooter />
    </ScrollArea>
  );
};

export default CookiePolicy;
